import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import "./pitch-deck-analysis.css";
// import CreateEditManagement from './create-edit-pitch-deck-analysis/management';
import PlanBuilderPageLayout from "../../../../layout/pitch-deck-analysis-page/index";
import { useSupabaseApp } from "../../../../SupabaseApp";
import useBusinessPlanBuilder from "../../../hooks/useBusinessPlanBuilder";
import {
  closeAlert,
  handleClose,
  handleEnterSave,
  handleSave,
  handleSubmit,
  scrollToTop,
} from "./helpers";

/**
 * CreatePitchDeckAnalysis Component
 *
 * Create new pitch deck analysis documents. Allows founders to build comprehensive
 * pitch decks with multiple sections for business planning and investor presentations.
 * Uses custom useBusinessPlanBuilder hook to manage form state and validation.
 * Fetches unique pitchDeckId on mount via Realm functions. Integrates with specialized
 * PlanBuilderPageLayout for rendering complex multi-section forms.
 * Supports saving, submitting, and keyboard shortcuts (Ctrl+Enter to save).
 * Requires user authentication via Realm.
 *
 * @returns {JSX.Element} Page with pitch deck creation form and builder interface
 */
const CreatePitchDeckAnalysis = () => {
  // Get pitch deck form state and dispatcher from custom hook
  const { state, dispatch } = useBusinessPlanBuilder();

  // State to control alert component visibility
  const [alert, setAlert] = useState(false);
  // State to store alert message content
  const [message, setMessage] = useState("");

  // Get current user and Realm functions for authentication
  const { supabase } = useSupabaseApp();

  // Realm functions to analyze, save, and generate unique IDs for pitch decks
  // const { analyzePitchDeckDev, savePitchDeckDev, generateAddEditFormId } =
  //   currentUser.functions;

  // Router history for navigation between pages
  const history = useHistory();

  /**
   * Generate unique pitchDeckId on component mount
   * Called once to create new document ID before user starts editing
   */
  useEffect(() => {
    if (!state.pitchDeckId) {
      async function getPitchDeckId() {
        const { data, error } = await supabase.functions.invoke(
          "generateAddEditFormId",
        );

        dispatch({ type: "update pitchDeckId", value: data });
      }
      try {
        getPitchDeckId();
      } catch (err) {
        // To-do: Alert user an error was returned
        // console.error("Unable to generate unique ID");
      }
    }
  }, []);

  // Props object passed to PlanBuilderPageLayout containing state, handlers, and helper functions
  const props = {
    state: state,
    dispatch: dispatch,
    setMessage,
    setAlert,
    message,
    alert,
    history,
    supabase,
  };

  // Props object with handler functions bound to components (closeAlert, scrollToTop, etc)
  const params = {
    ...props,
    closeAlert: () => closeAlert(props),
    scrollToTop: () => scrollToTop(),
    handleSubmit: () => handleSubmit(props),
    handleSave: () => handleSave(props),
    handleEnterSave: (e) => handleEnterSave(e),
    handleClose: () => handleClose(props),
  };

  return <PlanBuilderPageLayout props={params} />;
};

export default CreatePitchDeckAnalysis;
